<template>
  <div class="progressBarForSignUp" :class="{ isPc: !isSp }">
    <ul class="progressBarForSignUpList">
      <li
        v-for="(item, index) in processList"
        :key="item"
        class="progressBarForSignUpNumberWrapper"
        :class="{ disable: currentPhase < index + 1 }"
      >
        <p v-show="currentPhase <= index + 1 && currentPhase !== 4" class="progressBarForSignUpNumber">
          {{ index + 1 }}
        </p>
        <p v-show="currentPhase > index + 1 || currentPhase === 4" class="progressBarForSignUpNumber done"></p>
        <p class="progressBarForSignUpText">
          {{ item }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    currentPhase: {
      type: Number,
      required: true,
    },
    phaseList: {
      type: Object,
      required: true,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    processList() {
      return Object.values(this.phaseList).map((x) => x.text);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.progressBarForSignUp {
  padding: 16px 49px;
  background: $color-background-primary-third;
  display: flex;
  justify-content: center;

  &.isPc {
    padding: 24px 0 32px;
  }

  .progressBarForSignUpList {
    width: 280px;
    display: flex;

    .progressBarForSignUpNumberWrapper {
      display: flex;
      flex-direction: column;
      color: $color-sapuri-blue;
      width: 120px;
      text-align: center;
      position: relative;

      .progressBarForSignUpNumber {
        font-size: $text-size-caption1;
        font-weight: bold;
        box-sizing: border-box;
        margin: 0 auto;
        margin-bottom: 8px;
        width: 25px;
        height: 25px;
        border: $color-sapuri-blue 1px solid;
        border-radius: 50%;
        line-height: 25px;
        background: white;
        z-index: 2;

        // 完了したもの
        &.done {
          background: $color-sapuri-blue;
          position: relative;

          // 完了時の内側のチェックマーク
          &::before {
            content: '';
            height: 8px;
            width: 3px;
            position: absolute;
            border-bottom: solid 2px #fff;
            border-right: solid 2px #fff;
            left: 9px;
            top: 6px;
            transform: rotate(45deg);
          }
        }
      }

      // 完了時のプログレスバー
      &::before {
        z-index: 1;
        position: absolute;
        top: 11px;
        left: -40px;
        content: '';
        margin: auto 0;
        width: 65px;
        height: 4px;
        background: $color-sapuri-blue;
      }

      // 最初の要素にはプログレスバーださない
      &:first-child::before {
        content: none;
      }

      .progressBarForSignUpText {
        // 下にでてる文字
        font-size: $text-size-caption2;
        line-height: 1;
        height: 10px;
      }

      // 非活性の時の処理
      &.disable {
        color: #808d96;

        .progressBarForSignUpNumber {
          font-weight: normal;
          border: $color-background-primary-third-dark 1px solid;
        }

        // 非活性の時のプログレスバー
        &::before {
          background: $color-background-primary-third-dark;
        }
      }
    }
  }
}
</style>
